import { render } from "./App.vue?vue&type=template&id=c80a6d8c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c80a6d8c&lang=scss"
import "./App.vue?vue&type=style&index=1&id=c80a6d8c&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80a6d8c"]])

export default __exports__